<template>
  <b-navbar toggleable="md" type="dark" variant="dark" class="pl-2">
    <b-navbar-brand href="https://beluga.geomar.de"><img src="/beluga-web/static/geomar_logo.png" alt="Logo" style="height: 25px" class="mr-2 mb-1">
      <strong>BELUGA</strong> <span class="d-none d-sm-inline">Navigator </span><b-badge class="badge badge-info align-text-top ml-2 d-none d-sm-inline-block">Beta</b-badge>
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="#" active>Dashboard</b-nav-item>
        <b-nav-item disabled>Status</b-nav-item>
        <b-nav-item disabled>Data</b-nav-item>
        <b-nav-item disabled>Admin</b-nav-item>
        <b-nav-item disabled>Tools</b-nav-item>
        <b-nav-item href="https://www.geomar.de/en/tlz/auv-autonomous-underwater-vehicles/beluga" target="_blank">About</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    <span class="pull-right text-muted d-none d-lg-block mr-3"><small>Last build: {{ builddate }}</small></span>
    <b-button variant="light" size="sm" class="ml-auto" disabled>Login</b-button>
  </b-navbar>
</template>

<script>
export default {
  data () {
    return {
      builddate: process.env.VUE_APP_BUILDDATE
    }
  }
}
</script>
